import { render, staticRenderFns } from "./MdtWizardSimpleEmbedded.vue?vue&type=template&id=06b0355e&scoped=true"
import script from "./MdtWizardSimpleEmbedded.vue?vue&type=script&lang=js"
export * from "./MdtWizardSimpleEmbedded.vue?vue&type=script&lang=js"
import style0 from "./MdtWizardSimpleEmbedded.vue?vue&type=style&index=0&id=06b0355e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0355e",
  null
  
)

export default component.exports